import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import axios from 'axios';
import {OverlayTrigger, Button, Image, Modal, Carousel, CarouselItem, Glyphicon, Tooltip} from 'react-bootstrap';
//import {getLexemeProperties, getDescriptionLanguage} from './../../LexemePage';
import {
    getContextTypes,
    LexemeUtilities,
    LexemeEditingLevel,
    EditingStatusTypes,
    LexemePageInfos,
    LexemeDisplayContext
} from "../../editor/LexemeHelper";
import {SCSimpleSoundPlayer} from './../../../../dict-components/components';
import {LexemePageContext} from "../../LexemePageContext";
import stylesLexemeTitle from '../../../../_css/dictionary/lexemeParts/lexemeTitle.module.css';
import BUtils from './../../../../utilities/BaseUtilities';
import {SCFileViewer} from "../../../../dict-components/fileViewer/SCFileViewer";
import stylesScNavbar from "../../../../dict-components/navbar/ScNavbar.module.css";
import {BackOfficeTree} from "../../../../search/backOfficeSearch/BackOfficeTree";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";
import {getTopic} from "../../LexemePage";
import {userService} from "../../../../_redux/authentication/services/user.services";
import FontAwesome from "react-fontawesome";
import ReactTooltip from "react-tooltip";
import {performSearch} from '../../../../search/lib/search';

export class LexemeTitle extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: 'TITLE',
            id: "",
            audioSrc: this.props.page.title.multimedia_file,
            descrLang: '',
            showGallery: false,
            showPlaceFiles: false,
            showRules: false,
            defaultActiveImageIndex: 0,
            rules: [],
            selectedRule: -1,
            synonyms: [],
            showSynonyms: false,
            selectedSubentrySynonyms: null
        };

        this.storedUrl = BUtils.getServerUrl();
        this.isMobile = BUtils.isMobile();
        this.isEncyclopedic = AdministrationUtilities.isEncyclopedic();
        this.isSinglePage = this.props.displayContext === LexemeDisplayContext.SINGLE_PAGE || true;
        this.isExport = this.props.displayContext === LexemeDisplayContext.EXPORT;
        //this.legacyServiceSchema = 'http://dictionary-test.smallcodes.com:8081/scservices/' + (this.props.displayContext === LexemeDisplayContext.SINGLE_PAGE ? 'retrieveCgrSchemaForApp' : 'retrieveCgrSchema') + '/';
        this.legacyService = Dict.getGlobalProperty('LEGACY_SERVICE');
        this.legacyServiceSchema = this.legacyService !== null && this.legacyService.trim().length > 0 ? this.legacyService + (this.isSinglePage ? 'retrieveCgrSchemaForApp' : 'retrieveCgrSchema') + '/' : null;
    }

    componentWillMount() {
        this.setState({descrLang: AdministrationUtilities.getDescriptionLanguageByContext(this.context)});//AdministrationUtilities.getDescriptionLanguage(this.context.languageId)});
    }

    componentDidMount() {
        if (LexemePageInfos.isToponym(this.context) && typeof this.props.page.place !== 'undefined' && this.props.page.place.id !== null) {
            Dict.call('service/search/retrieveBackOfficeEntityFields/Place/' + this.props.page.place.id + '/').then((result) => {
                var placeData = JSON.parse(JSON.stringify(this.props.page.place));
                placeData.multimediaFiles = BUtils.sortMultimediaFiles(result.entityFields.galleryMultimedia.value);

                this.setState({placeData});
            });
        }

        if (this.legacyServiceSchema !== null) {
            var urls = this.props.page.subentries.map((subentry) => {
                return this.legacyServiceSchema + subentry.ids;
            })

            Promise.all(urls.map(url => axios.get(url))).then((result) => {
                var rules = result.filter((resFilter) => {
                    return typeof resFilter.data.text !== 'undefined';
                }).map((res) => {
                    return res.data.text.replace('600px', '500px');
                });

                this.setState({rules})
            })
        }

        // Recupera i sinonimi tramite le Entry traducenti, raggruppati per accezione
        const entryId = this.props.page.lexeme_properties.entry_id;
        const translationsEntryIds = [];
        (this.props.page.subentries || []).forEach((subentry) => {
            const sensesData = [];
            (subentry.senses || []).forEach((sense) => {
                const senseTranslationIds = [];
                (sense.translation_group || []).forEach((group) => {
                    (group.translations || []).forEach((translation) => {
                        if (translation.entry_id && !senseTranslationIds.includes(translation.entry_id)) {
                            senseTranslationIds.push(translation.entry_id);
                        }
                    });
                });
                if (senseTranslationIds.length > 0) {
                    const senseDescr = sense.description && sense.description.length > 0 ? sense.description[0].description : null;
                    sensesData.push({
                        senseIds: sense.ids,
                        senseDescription: senseDescr,
                        senseOrderFactor: sense.order_factor || 0,
                        translationsEntryIds: senseTranslationIds
                    });
                }
            });
            if (sensesData.length > 0) {
                translationsEntryIds.push({
                    id: subentry.ids,
                    description: subentry.cgr ? subentry.cgr.description : null,
                    subentryForm: subentry.subentry_form || null,
                    senses: sensesData
                });
            }
        });

        if (entryId && translationsEntryIds.length > 0) {
            Dict.call('page/retrieveSynonyms/' + entryId + '/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                data: JSON.stringify(translationsEntryIds)
            }).then((result) => {
                if (result && Array.isArray(result)) {
                    // Filtra solo le subentry che hanno almeno un'accezione con sinonimi
                    const synonyms = result.filter((item) => item.senses && item.senses.some(s => s.synonyms && s.synonyms.length > 0));
                    this.setState({synonyms});
                }
            });
        }
    }

    _createButtonBarTooltip() {
        return LexemeUtilities.createButtonBarTooltip(this);
    }

    _isActive(id) {
        return LexemeUtilities.isActive(this, id, true);
    }

    _highlightSense(senseIds) {
        var senseObj = document.getElementById("su-ids-" + senseIds).parentElement;
        senseObj.classList.add("hightlight-image");
    }

    _removeHighlightSense(senseIds) {
        var senseObj = document.getElementById("su-ids-" + senseIds).parentElement;
        senseObj.classList.remove("hightlight-image");
    }

    _openImageGallery(index) {
        this.setState({showGallery: true, defaultActiveImageIndex: index});
    }

    _openCgrSchema(selectedRule) {
        this.setState({selectedRule, showRules: true});
    }

    _handleClick(id) {

        if (LexemeUtilities.useEditor(this.context.pageStatus) || LexemeUtilities.useTitleEditor(this.context.pageStatus)) {
            const active = document.getElementsByClassName(LexemeUtilities.getLexClass(this) + "Active");
            const activeLevel = document.getElementsByClassName(LexemeUtilities.getLexLevelClass(this) + "Active");

            if (active.length > 0) {
                active[0].click();
            }

            if (activeLevel.length > 0) {
                activeLevel[0].click();
            }

            this.setState({
                id: (id === this.state.id ? '' : id)
            });
        }
    }

    render() {

        var title = this.props.page.title;
        const dictProps = this.props.page.dictionary_properties;
        const isLexeme = LexemePageInfos.isLexeme(this.context);
        const hasMultimedia = typeof title.multimedia_file !== 'undefined' && Object.keys(title.multimedia_file).length > 0;
        const place = this.props.page.place;
        const isHidden = this.props.page.lexeme_properties.is_hidden;
        const isExternalDict = this.props.page.isExternalDict;

        //const main_form = typeof title.main_form !== null && typeof main_form !== title.entry_form ? title.main_form.main_form + ' → ' + title.entry_form : title.entry_form; // === 'weilen' ? baddarone.title.entry_form : title.entry_form;
        //const print_title = typeof title.print_title !== 'undefined' ? title.print_title : title.entry_form;
        const print_title = title.print_title//typeof title.main_form !== 'undefined' && title.main_form !== null ? /*title.entry_form + ' → ' + */title.main_form.main_form : title.entry_form;
        const homo = title.homographic;
        var langList = '';
        if (isLexeme) {
            langList = title.language_list
        } else if (this.context.properties.secondary_languages.length > 0) {
            langList = this.context.dictProperties.language_code;
        }

        var dictWay = dictProps.is_inverse ? "Inverse" : "Direct";

        const isToponym = LexemePageInfos.isToponym(this.context);
        const hasPlace = isToponym && typeof place !== 'undefined'
        const printPlace = hasPlace ? <>
            <Glyphicon className={stylesLexemeTitle['lex-title-place-button']} onClick={() => {
                this.setState({showPlaceFiles: true})
            }} glyph={'briefcase'}/>
            <Glyphicon className={stylesLexemeTitle['lex-title-place-button']} onClick={() => {
                this.setState({showPlaceTree: true})
            }} glyph={'tree-conifer'}/>
        </> : '';


        const images = this.props.page.title.images.map((item, index) => {
            const prefix = item.multimedia_crop_image.startsWith('http') ? '' : this.storedUrl + '/';
            return <div className={stylesLexemeTitle['title-image-list__item']} key={"key-title-image-" + item.senseIds}
                        onMouseOver={() => {
                            this._highlightSense(item.senseIds)
                        }}
                        onMouseOut={() => {
                            this._removeHighlightSense(item.senseIds)
                        }}
                        onClick={() => this._openImageGallery(index)}
            ><Image src={prefix + item.multimedia_crop_image}/></div>;
        });

        const galleryImages = this.props.page.title.images.map((item) => {
            const prefix = item.multimedia_crop_image.startsWith('http') ? '' : this.storedUrl + '/';
            return <CarouselItem key={"key-carousel-item-" + item.senseIds}>
                <div className={stylesLexemeTitle['gallery-carousel__div']}>
                    <img src={prefix + item.multimedia_image} className={stylesLexemeTitle['gallery-carousel__img']}
                         alt={''}/>
                </div>
                <Carousel.Caption>
                    <h3>{item.title}</h3>
                    <p>{item.caption}</p>
                </Carousel.Caption>
            </CarouselItem>
        });

        const editingStatusTooltip = <Tooltip
            placement="left" className="in" id="tooltip">
            {Dict.t(this.props.page.title.editing_status)}
        </Tooltip>;

        var editingStatus = typeof this.props.page.title.editing_status !== 'undefined' ? this.props.page.title.editing_status : 'ANY';

        return <div
            className={BUtils.joinClasses(stylesLexemeTitle['lexeme-title'], stylesLexemeTitle['lexeme-title--' + dictWay], stylesLexemeTitle['lexeme-title-is-export--' + this.isExport], stylesLexemeTitle['lexeme-hidden--' + isHidden])}>
            {this.context.pageStatus === LexemeEditingLevel.EDITABLE ?
                <div
                    className={BUtils.joinClasses(stylesLexemeTitle['lexeme-editing-status'], stylesLexemeTitle['lexeme-editing-status--' + editingStatus])}>
                    <OverlayTrigger placement="left" overlay={editingStatusTooltip} delayShow={300}
                                    delayHide={150}><Glyphicon
                        glyph={EditingStatusTypes[editingStatus].glyphicon}/></OverlayTrigger>
                </div> : ""}
            {this.context.pageStatus === LexemeEditingLevel.EDITABLE && !this.isEncyclopedic ?
                <div
                    className={BUtils.joinClasses(stylesLexemeTitle['lexeme-status'], stylesLexemeTitle['lexeme-status--' + this.props.page.title.lexeme_status])}>&nbsp;</div> : ""}
            <OverlayTrigger delay={8000} key={"key-lexEntry"} rootClose={false}
                            trigger={"click"}
                            placement="right"
                            overlay={this._createButtonBarTooltip()}>
                <div
                    className={BUtils.joinClasses(stylesLexemeTitle['lex-title-entryForm'], stylesLexemeTitle['lex-title-entryForm__mobile--' + this.isMobile], LexemeUtilities.getLexLevelClass(this), LexemeUtilities.getLexClass(this), this._isActive(LexemePageInfos.getLexemeProperties(this.context, "root_entry_id")))}
                    onClick={() => {
                        this._handleClick(LexemePageInfos.getLexemeProperties(this.context, "root_entry_id"))
                    }}>{print_title}</div>
            </OverlayTrigger>
            <div
                className={BUtils.joinClasses(stylesLexemeTitle['lextTitleHomo'], stylesLexemeTitle['lextTitleHomo--' + homo])}>{homo}</div>
            {!isExternalDict && langList.length > 0 ?
                <div className={stylesLexemeTitle["lexTitleLangList"]}>{langList}</div> : ""}
            {isExternalDict ? <div
                className={stylesLexemeTitle["lexTitleExternalDict"]}>{Dict.t('FROM_DICTIONARY') + ' ' + this.props.page.externalDictName}</div> : ""}
            {hasMultimedia && (this.context.displayContext === LexemeDisplayContext.DICTIONARY_SEARCH || this.context.displayContext === LexemeDisplayContext.SINGLE_PAGE) ?
                <div
                    className={BUtils.joinClasses(stylesLexemeTitle['div-entry-audio-container'], stylesLexemeTitle['div-entry-audio-container__mobile--' + this.isMobile])}>
                    <SCSimpleSoundPlayer
                        additionalClass={this.isMobile ? 'mobile-media-controls-play' : ''}
                        src={this.props.page.title.multimedia_file /*+ '?v=' + new Date().getMilliseconds()*/}/>
                </div> : ""}
            {this.state.rules.map((rule, index) => {
                const idToolTip = 'cgr-schema-tooltip-' + index;
                return <>
                    <ReactTooltip id={idToolTip} className={stylesLexemeTitle['cgr-schema-button-tooltip']} type='info'
                                  delayShow={100}>
                        {Dict.t('VERB_SCHEMA_OF') + ' ' + (this.props.page.subentries[index].cgr.description).toUpperCase()}
                    </ReactTooltip>
                    <Button
                        className={BUtils.joinClasses(stylesLexemeTitle['cgr-schema-button'], stylesLexemeTitle['cgr-schema-button__' + (index + 1)])}
                        data-tip data-for={idToolTip}
                        onClick={() => {
                            this._openCgrSchema(index);
                        }}>{[index + 1]}</Button>
                </>
            })}
            {images.length > 0 ? <div className={stylesLexemeTitle['title-image-list']}>{images}</div> : ""}
            {this.state.synonyms.length > 0 ?
                <Glyphicon
                    className={BUtils.joinClasses(stylesLexemeTitle['synonyms-button'], stylesLexemeTitle['synonyms-button__mobile--' + this.isMobile])}
                    glyph={'transfer'}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.color = '#737373';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = '';
                    }}
                    onClick={() => this.setState({
                        showSynonyms: true,
                        selectedSubentrySynonyms: this.state.synonyms[0]
                    })}
                /> : ""}
            {this.state.synonyms.length > 0 ?
                <Modal
                    id={'dict-modal-synonyms-' + this.props.page.lexeme_properties.entry_id}
                    show={this.state.showSynonyms}
                    onHide={() => this.setState({showSynonyms: false, selectedSubentrySynonyms: null})}
                    bsSize={this.isMobile ? "small" : undefined}
                    dialogClassName={BUtils.joinClasses(stylesLexemeTitle['modal-synonyms__dialog'], stylesLexemeTitle['modal-synonyms__dialog__mobile--' + this.isMobile])}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Dict.t('SYNONYMS') + ' - ' + title.entry_form}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{maxHeight: '650px', overflowY: 'auto'}}>
                        {this.state.synonyms.length > 1 &&
                            <div style={{marginBottom: '8px', display: 'flex', gap: '6px', flexWrap: 'wrap'}}>
                                {this.state.synonyms.map((item) => (
                                    <Button
                                        key={'syn-tab-' + item.id}
                                        bsSize="big"
                                        bsStyle={this.state.selectedSubentrySynonyms && this.state.selectedSubentrySynonyms.id === item.id ? 'primary' : 'default'}
                                        onClick={() => this.setState({selectedSubentrySynonyms: item})}>
                                        {item.subentryForm ? (item.description || '') + ' ' + item.subentryForm : (item.description || item.id)}
                                    </Button>
                                ))}
                            </div>
                        }
                        <div>
                            {(this.state.selectedSubentrySynonyms ? this.state.selectedSubentrySynonyms.senses : [])
                                .filter(senseGroup => senseGroup.synonyms && senseGroup.synonyms.length > 0)
                                .map((senseGroup) => (
                                    <div key={'sense-group-' + senseGroup.senseIds}>
                                        {(senseGroup.senseDescription || senseGroup.senseOrderFactor) &&
                                            <div style={{
                                                fontStyle: 'italic',
                                                color: '#888',
                                                marginTop: '8px',
                                                marginBottom: '0',
                                                fontSize: '18px',
                                                paddingLeft: '4px'
                                            }}>
                                                {senseGroup.senseDescription || senseGroup.senseOrderFactor}
                                            </div>
                                        }
                                        <ul style={{listStyle: 'none', padding: 0, margin: '0 0 0 18px'}}>
                                            {senseGroup.synonyms.map((syn) => (
                                                <li key={'syn-' + syn.id}
                                                    style={{
                                                        padding: '4px 0',
                                                        borderBottom: '1px solid #eee',
                                                        cursor: 'pointer'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#e0e0e0';
                                                        e.currentTarget.style.borderRadius = '4px';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = '';
                                                        e.currentTarget.style.borderRadius = '';
                                                    }}
                                                    onClick={() => {
                                                        const langId = this.props.page.lexeme_properties.language_id;
                                                        const langCode = this.props.page.dictionary_properties.language_code;
                                                        LexemeUtilities.openLexemePage(syn.id, syn.id, true, this.props.pageStatus, syn.label, null, '', langId, langCode, undefined);
                                                    }}>
                                                    <div style={{display: 'flex', gap: '12px', alignItems: 'baseline'}}>
                                                        <span style={{
                                                            fontWeight: 'normal',
                                                            fontSize: 18
                                                        }}>{syn.label}</span>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))
                            }
                        </div>
                    </Modal.Body>
                </Modal> : ""}
            {images.length > 0 ?
                <Modal className={stylesLexemeTitle['modal-title-gallery']} show={this.state.showGallery}
                       onHide={() => this.setState({showGallery: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Dict.t('IMAGE_GALLERY_OF')}&nbsp;
                            <strong>{title.entry_form}</strong></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Carousel slide={true} interval={null}
                                  defaultActiveIndex={this.state.defaultActiveImageIndex}>
                            {galleryImages}
                        </Carousel>
                    </Modal.Body>
                </Modal> : ""}
            {printPlace}
            {isToponym ?
                <><Modal className={stylesLexemeTitle['modal-title-place']} show={this.state.showPlaceFiles}
                         dialogClassName={stylesLexemeTitle['modal-title-place__dialog-modal']}
                         onHide={() => this.setState({showPlaceFiles: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <strong>{hasPlace ? place.description : ''}</strong>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsClass={stylesLexemeTitle['modal-title-place__body']}>
                        <SCFileViewer
                            item={this.state.placeData}
                            itemType={'Place'}
                            editable={false}
                            additionalClass={stylesLexemeTitle['modal-title-place-viewer-additional']}
                        />
                    </Modal.Body>
                </Modal>
                    <Modal className={stylesLexemeTitle['modal-title-place']} show={this.state.showPlaceTree}
                           dialogClassName={stylesLexemeTitle['modal-title-place__dialog-modal']}
                           onHide={() => this.setState({showPlaceTree: false})}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <strong>{Dict.t('PLACE_TREE')}</strong>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body bsClass={stylesLexemeTitle['modal-title-place-tree__body']}>
                            <BackOfficeTree entity={'Place'}
                                            expandedKey={hasPlace ? place.id : ''}
                                            selectable={false}
                                            frontend={true}
                                            callbackSelect={(item) => {
                                            }}
                            />
                        </Modal.Body>
                    </Modal>
                </> : ""}
            {this.state.selectedRule >= 0 ?
                <Modal className={stylesLexemeTitle['modal-cgr-schema']} show={this.state.showRules}
                       dialogClassName={stylesLexemeTitle[this.isSinglePage ? 'modal-title-phone-cgr-schema__dialog-modal' : 'modal-title-cgr-schema__dialog-modal']}
                       onHide={() => this.setState({showRules: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Dict.t('VERB_SCHEMA_OF') + ' ' + (this.props.page.subentries[this.state.selectedRule].cgr.description).toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body dangerouslySetInnerHTML={{__html: this.state.rules[this.state.selectedRule]}}>
                    </Modal.Body>
                </Modal> : ""}
        </div>;
    }
}

LexemeTitle.contextType = LexemePageContext;
